// API URL'si - bu sabit, API endpoint'lerimiz için temel URL'yi tanımlar
export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8012/api';

// Uygulama başlatılırken API URL'yi konsola yazdırarak kontrol
console.log('[config] API URL:', API_URL);

// Diğer sabit değerler buraya eklenebilir